export const STATUS_CODE_OPTIONS = [
  {
    value: 'LOAN_STATUS_CREATED',
    label: 'ایجاد شده',
  },

  {
    value: 'LOAN_STATUS_CANCELED',
    label: 'لغوشده',
  },
  {
    value: 'LOAN_STATUS_DONE',
    label: 'پرداخت‌شده',
  },
  {
    value: 'LOAN_STATUS_REVOKED',
    label: 'باطل‌شده',
  },
  {
    value: 'LOAN_STATUS_WAITING_TO_CREATE',
    label: 'در انتظار ایجاد',
  },
];

export const INSTALLMENT_STATUS_CODE = [
  {
    value: 'INSTALLMENT_STATUS_CREATED',
    label: 'ایجاد شده',
  },
  {
    value: 'INSTALLMENT_STATUS_CANCELED',
    label: 'لغوشده',
  },
  {
    value: 'INSTALLMENT_STATUS_REVOKED',
    label: 'باطل‌شده',
  },
  {
    value: 'INSTALLMENT_STATUS_DONE',
    label: 'پرداخت‌شده',
  },
  {
    value: 'INSTALLMENT_STATUS_WAITING_FOR_BANK_SETTLEMENT',
    label: 'در انتظار تسویه در بانک',
  },
  {
    value: 'INSTALLMENT_STATUS_PRE_SETTLED',
    label: 'تسویه زودتر از موعد شده',
  },
  {
    value: 'INSTALLMENT_STATUS_DELETED',
    label: 'حذف شده',
  },
  {
    value: 'INSTALLMENT_STATUS_DEFERRED',
    label: 'به تعویق افتاده',
  },
  {
    value: 'INSTALLMENT_STATUS_INCOMPLETE_PAYMENT',
    label: 'پرداخت ناقص',
  },
];

export const CLEAR_INSTALLMENT_TOOL_CODE = [
  {
    value: 'LOAN_CLEAR_INSTALLMENT_TOOL_WALLET',
    label: 'حساب دیجیتال پاد',
  },
  {
    value: 'LOAN_CLEAR_INSTALLMENT_TOOL_DIRECT_DEBIT',
    label: 'مجوزهای برداشت از حساب بانکی',
  },
  {
    value: 'LOAN_CLEAR_INSTALLMENT_TOOL_BANK_ACCOUNT_NUMBER',
    label: 'شماره کارت بانکی',
  },
];

export const CREATED_OFFLINE_OPTIONS = [
  {
    value: 'true',
    label: 'بله',
  },
  {
    value: 'false',
    label: 'خیر',
  },
];

export const GUARANTOR_CODE_OPTIONS = [
  {
    value: 'LOAN_GUARANTOR_NO_GUARANTOR',
    label: 'بدون ضامن',
  },
  {
    value: 'LOAN_GUARANTOR_PASARGAD',
    label: 'با ضمانت بانک پاسارگاد',
  },
];

export const LOAN_STATUS = [
  {
    value: 'LOAN_ITEM_INVOICE_REVOKED',
    label: 'لغو شده',
  },
  {
    value: 'LOAN_ITEM_INVOICE_CANCELED',
    label: 'برگشت داده شده',
  },


  {
    value: 'LOAN_ITEM_INVOICE_REGISTER_WAITING',
    label: 'در انتظار ثبت در بانک',
  },
  {
    value: 'LOAN_ITEM_INVOICE_SENDING',
    label: 'ارسال شده برای ثبت در بانک',
  },

  {
    value: 'LOAN_ITEM_INVOICE_PENDING',
    label: 'در انتظار',
    //label: 'ثبت شده در بانک',
  },

  {
    value: 'LOAN_ITEM_INVOICE_REGISTER',
    label: 'ثبت شده در بانک',
  },

  {
    value: 'LOAN_ITEM_INVOICE_REGISTER_FAILED',
    label: 'خطا در زمان ثبت در بانک',
  },
];
